export const mockCustomerType: -1 | 0 | 1 | 2 | 3 = 3;

export const mockCustomerProducts = async () => {
	await new Promise((resolve) => setTimeout(resolve, 2500));
	switch (mockCustomerType) {
		case -1:
		case 0:
			return { policies: [] };
		case 1:
			return { policies: [mockCustomerProducts_.policies[0]] };
		case 2:
			return { policies: [mockCustomerProducts_.policies[0], mockCustomerProducts_.policies[1]] };
		default:
			return mockCustomerProducts_;
	}
};

const mockCustomerProducts_ = {
	_links: {
		self: {
			href: '/common/policies',
		},
	},
	currency: 'DKK',
	page: {
		size: 69,
		total_items: 69,
		total_pages: 1,
		number: 1,
	},
	page_total: {
		amount: 151958,
	},
	policies: [
		{
			id: '124110316',
			policy_number: '214678632',
			type: 'home',
			status: {
				title: 'status',
				subtitle: 'Afventer',
				type: 'PENDING',
			},
			group: {
				title: 'Bolig',
				type: 'housing',
			},
			url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125201810?search.page=1&search.size=50&search.include_own=true',
			title: 'Indboforsikring',
			subtitle: 'Mimersvej 18, 3000 Helsingør',
			conditionNo: 'COPI 2500',
			price: {
				title: 'Pris pr. år',
				amount: 2345,
				charged: 'EVERY_YEAR',
				unit: 'kr',
			},
			start: {
				title: 'Startdato',
				date: '2026-03-01',
			},
			end: {
				title: 'Forfaldsdato',
				date: '2027-02-28',
			},
			currentPolicyStatus: 'PENDING',
		},
		{
			id: '124133932',
			policy_number: '214697548',
			type: 'house',
			status: {
				title: 'status',
				subtitle: 'I Kraft',
				type: 'ACTIVE',
			},
			group: {
				title: 'Bolig',
				type: 'housing',
			},
			url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225240?search.page=1&search.size=50&search.include_own=true',
			title: 'Husforsikring',
			subtitle: 'Parkvej 12, 3250 Gilleleje',
			conditionNo: 'COPE 2500',
			price: {
				title: 'Pris pr. år',
				amount: 13341,
				charged: 'EVERY_YEAR',
				unit: 'kr',
			},
			end: {
				title: 'Forfaldsdato',
				date: '2027-03-31',
			},
			currentPolicyStatus: 'ACTIVE',
		},
		{
			id: '124143629',
			policy_number: '214705613',
			type: 'car',
			status: {
				title: 'status',
				subtitle: 'Afventer',
				type: 'PENDING',
			},
			group: {
				title: 'Køretøj',
				type: 'vehicles',
			},
			url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125234869?search.page=1&search.size=50&search.include_own=true',
			title: 'Bilforsikring',
			subtitle: 'SUZUKI CELERIO, Uk en dt',
			conditionNo: 'COPC 0426',
			price: {
				title: 'Pris pr. år',
				amount: 980,
				charged: 'EVERY_YEAR',
				unit: 'kr',
			},
			start: {
				title: 'Startdato',
				date: '2026-05-01',
			},
			end: {
				title: 'Forfaldsdato',
				date: '2027-04-30',
			},
			currentPolicyStatus: 'PENDING',
		},
		{
			id: '124133850',
			policy_number: '214682818',
			type: 'dog',
			status: {
				title: 'status',
				subtitle: 'I Kraft',
				type: 'ACTIVE',
			},
			group: {
				title: 'Familie og fritid',
				type: 'family',
			},
			url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225159?search.page=1&search.size=50&search.include_own=true',
			title: 'Hundeforsikring',
			subtitle: 'Fido, Alaskan malamute',
			conditionNo: 'VP 1505',
			price: {
				title: 'Pris pr. år',
				amount: 603,
				charged: 'EVERY_YEAR',
				unit: 'kr',
			},
			end: {
				title: 'Forfaldsdato',
				date: '2027-03-31',
			},
			currentPolicyStatus: 'ACTIVE',
		},
		{
			id: '124134294',
			policy_number: '214688883',
			type: 'holidayhouse',
			status: {
				title: 'status',
				subtitle: 'I Kraft',
				type: 'ACTIVE',
			},
			group: {
				title: 'Bolig',
				type: 'housing',
			},
			url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225599?search.page=1&search.size=50&search.include_own=true',
			title: 'Fritidshusforsikring',
			subtitle: 'Mimersvej 1, 9800 Hjørring',
			conditionNo: 'COPR 2500',
			price: {
				title: 'Pris pr. år',
				amount: 19021,
				charged: 'EVERY_YEAR',
				unit: 'kr',
			},
			end: {
				title: 'Forfaldsdato',
				date: '2027-03-31',
			},
			currentPolicyStatus: 'ACTIVE',
		},
		{
			id: '124112194',
			policy_number: '214674653',
			type: 'accident',
			status: {
				title: 'status',
				subtitle: 'I Kraft',
				type: 'ACTIVE',
			},
			group: {
				title: 'Helbred og sundhed',
				type: 'health',
			},
			url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203687?search.page=1&search.size=50&search.include_own=true',
			title: 'Ulykkesforsikring',
			subtitle: 'Mamta',
			conditionNo: 'COPU 2500',
			price: {
				title: 'Pris pr. år',
				amount: 1510,
				charged: 'EVERY_YEAR',
				unit: 'kr',
			},
			end: {
				title: 'Forfaldsdato',
				date: '2027-02-28',
			},
			currentPolicyStatus: 'ACTIVE',
		},

		// {
		// 	id: '124136224',
		// 	policy_number: '214682176',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125227509?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1463,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124119922',
		// 	policy_number: '214687941',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125211368?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'something something, 12 3',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1078,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124111784',
		// 	policy_number: '214679108',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203273?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'Fido, Airedale terrier',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124133826',
		// 	policy_number: '214688964',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225135?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124133995',
		// 	policy_number: '214684632',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225303?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134079',
		// 	policy_number: '214684764',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225386?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134276',
		// 	policy_number: '214688727',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225580?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 705,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124146810',
		// 	policy_number: '214709201',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125238036?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'AUDI A3, Uk en dt',
		// 	conditionNo: 'COPC 0426',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 2135,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-05-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124111854',
		// 	policy_number: '214638037',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203345?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 689,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134078',
		// 	policy_number: '214684756',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225385?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124115645',
		// 	policy_number: '214683369',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125207119?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog blanding',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124133989',
		// 	policy_number: '214698862',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225297?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Akita / American Akita',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 461,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124119931',
		// 	policy_number: '214687976',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125211377?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'something something, 12 3',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1078,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124152744',
		// 	policy_number: '214703343',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125243932?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1617,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124133993',
		// 	policy_number: '214684527',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225301?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134286',
		// 	policy_number: '214689391',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225591?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 705,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124112341',
		// 	policy_number: '214669420',
		// 	type: 'caravan',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203835?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Campingvognsforsikring',
		// 	subtitle: 'test test, AA 12 32',
		// 	conditionNo: 'COCV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 2832,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124119924',
		// 	policy_number: '214687968',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125211370?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'something something, 12 3',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1078,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134049',
		// 	policy_number: '214684640',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225356?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134080',
		// 	policy_number: '214682087',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225387?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'Fido, Affenpinscher',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124110908',
		// 	policy_number: '214679035',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125202397?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1463,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-03-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124119973',
		// 	policy_number: '214687992',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125211419?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'something something, 12 3',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1078,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124112337',
		// 	policy_number: '214669439',
		// 	type: 'pleasure_craft',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203831?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Lystfartøjsforsikring',
		// 	subtitle: '12 TEST',
		// 	conditionNo: 'COLF 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 11297,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124139698',
		// 	policy_number: '214701561',
		// 	type: 'moped',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125230964?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Knallertforsikring',
		// 	subtitle: 'APOLLO 36 RX Xtreme, FN 41 15',
		// 	conditionNo: '6263',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1234,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-03-09',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124134288',
		// 	policy_number: '214689405',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225593?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 705,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124115652',
		// 	policy_number: '214683377',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125207126?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, Alpenländische dachsbracke',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124152733',
		// 	policy_number: '214713462',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125243921?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 600,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124110176',
		// 	policy_number: '214678128',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125201671?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'Test, Balkan støver',
		// 	conditionNo: 'COVP 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 488,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-01-27',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2026-12-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124119943',
		// 	policy_number: '214687984',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125211389?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'something something, 12 3',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1078,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124111797',
		// 	policy_number: '214679159',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203286?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'AUDI Mod, ',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 911,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124132017',
		// 	policy_number: '214698994',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125223340?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'AUDI A4, ',
		// 	conditionNo: 'COPC 0426',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 8612,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124149829',
		// 	policy_number: '214712563',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125241033?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'AUDI A1, AB C1 23',
		// 	conditionNo: 'COPC 0426',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1887,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-05-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124136163',
		// 	policy_number: '214700301',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125227448?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'TESLA MODEL 3, CP 63 316',
		// 	conditionNo: 'COPC 0426',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 28796,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-05-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124112338',
		// 	policy_number: '214669455',
		// 	type: 'moped',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203832?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Knallertforsikring',
		// 	subtitle: 'test test, ',
		// 	conditionNo: 'COUK 6262',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1133,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134244',
		// 	policy_number: '214688654',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225548?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Afghansk mynde',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124130607',
		// 	policy_number: '214697610',
		// 	type: 'holidayhouse',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Bolig',
		// 		type: 'housing',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125221920?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Fritidshusforsikring',
		// 	subtitle: 'Parkvej 12, 3250 Gilleleje',
		// 	conditionNo: 'COPR 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 20273,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124133988',
		// 	policy_number: '214682893',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225296?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog blanding',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 603,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124136162',
		// 	policy_number: '214700298',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125227447?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'TESLA MODEL 3, CP 63 316',
		// 	conditionNo: 'COPC 0426',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 28796,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-03-04',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124134227',
		// 	policy_number: '214688646',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225531?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, Anatolsk hyrdehund',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134228',
		// 	policy_number: '214684934',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225532?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134275',
		// 	policy_number: '214689286',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225579?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Alpenländische dachsbracke',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124133994',
		// 	policy_number: '214691973',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225302?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Afghansk mynde',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124133779',
		// 	policy_number: '214698781',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225087?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 600,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124112339',
		// 	policy_number: '214669471',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203833?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'test 20, AA 21 21',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 971,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124119991',
		// 	policy_number: '214688018',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125211437?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'something something, 12 3',
		// 	conditionNo: '10.2',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1078,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124114586',
		// 	policy_number: '214682257',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125206065?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'Fido, Afghansk mynde',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124133909',
		// 	policy_number: '214689553',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225218?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Afghansk mynde',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134295',
		// 	policy_number: '214688913',
		// 	type: 'house',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Bolig',
		// 		type: 'housing',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225600?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Husforsikring',
		// 	subtitle: 'Mimersvej 1, 4600 Køge',
		// 	conditionNo: 'COPE 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 16064,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124110196',
		// 	policy_number: '214678160',
		// 	type: 'trailer',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125201691?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Påhængsvognsforsikring',
		// 	subtitle: 'Test Test, HW 63 77',
		// 	conditionNo: 'COPV 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 874,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2026-12-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134245',
		// 	policy_number: '214688662',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225549?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Airedale terrier',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134254',
		// 	policy_number: '214698153',
		// 	type: 'holidayhouse',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Bolig',
		// 		type: 'housing',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225558?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Fritidshusforsikring',
		// 	subtitle: 'Parkvej 12, 3250 Gilleleje',
		// 	conditionNo: 'COPR 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 20273,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124114649',
		// 	policy_number: '214681765',
		// 	type: 'holidayhouse',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Bolig',
		// 		type: 'housing',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125206128?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Fritidshusforsikring',
		// 	subtitle: 'Parkvej 12, 3250 Gilleleje',
		// 	conditionNo: 'COPR 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 34745,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124144982',
		// 	policy_number: '214706210',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125236219?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'AUDI A3, Uk en dt',
		// 	conditionNo: 'COPC 0426',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1425,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-05-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124134243',
		// 	policy_number: '214690489',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225547?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134258',
		// 	policy_number: '214688697',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225562?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Airedale terrier',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134086',
		// 	policy_number: '214682168',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225393?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1463,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124114541',
		// 	policy_number: '214682044',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125206020?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1531,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124114653',
		// 	policy_number: '214682419',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125206132?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIdo, American Bulldog',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-04-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124149643',
		// 	policy_number: '214712245',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'Afventer',
		// 		type: 'PENDING',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125240856?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1617,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	start: {
		// 		title: 'Startdato',
		// 		date: '2026-05-01',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-04-30',
		// 	},
		// 	currentPolicyStatus: 'PENDING',
		// },
		// {
		// 	id: '124134257',
		// 	policy_number: '214688689',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225561?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'DOG, Airedale terrier',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124111767',
		// 	policy_number: '214679094',
		// 	type: 'car',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Køretøj',
		// 		type: 'vehicles',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203256?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Bilforsikring',
		// 	subtitle: 'AUDI Mod, AB 12 34',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 911,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124134081',
		// 	policy_number: '214688565',
		// 	type: 'dog',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125225388?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Hundeforsikring',
		// 	subtitle: 'FIDO, American Bulldog blanding',
		// 	conditionNo: 'VP 1505',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 542,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-03-31',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
		// {
		// 	id: '124111809',
		// 	policy_number: '214636980',
		// 	type: 'travel',
		// 	status: {
		// 		title: 'status',
		// 		subtitle: 'I Kraft',
		// 		type: 'ACTIVE',
		// 	},
		// 	group: {
		// 		title: 'Familie og fritid',
		// 		type: 'family',
		// 	},
		// 	url: 'https://ca-api-common-policy-ci.wonderfulsmoke-129c9323.westeurope.azurecontainerapps.io/common/policies/125203300?search.page=1&search.size=50&search.include_own=true',
		// 	title: 'Rejseforsikring',
		// 	subtitle: 'Dækker Europa',
		// 	conditionNo: 'COPT 2500',
		// 	price: {
		// 		title: 'Pris pr. år',
		// 		amount: 1098,
		// 		charged: 'EVERY_YEAR',
		// 		unit: 'kr',
		// 	},
		// 	end: {
		// 		title: 'Forfaldsdato',
		// 		date: '2027-02-28',
		// 	},
		// 	currentPolicyStatus: 'ACTIVE',
		// },
	],
	household_relationships: [],
};
